import { render, staticRenderFns } from "./vsds.vue?vue&type=template&id=40caf1ac&scoped=true&"
import script from "./vsds.vue?vue&type=script&lang=js&"
export * from "./vsds.vue?vue&type=script&lang=js&"
import style0 from "./vsds.vue?vue&type=style&index=0&id=40caf1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40caf1ac",
  null
  
)

export default component.exports